import { useEffect } from 'react';

const usePendingCheckoutRedirect = ({ user, pendingCheckout, setPendingCheckout, navigate }) => {
  useEffect(() => {
    if (user && pendingCheckout) {
      setPendingCheckout(false);
      navigate('/checkout-start', { replace: true });
    }
  }, [user, pendingCheckout, setPendingCheckout, navigate]);
};

export default usePendingCheckoutRedirect;
